<ng-container *transloco="let t">
  <div id="cookies-disabled-page" class="min-h-screen bg-ld-neutral-50 flex items-center justify-center p-4">
    <div class="max-w-md w-full bg-white rounded-2xl shadow-card p-8 text-center">
      <div
        id="cookies-disabled-icon"
        class="size-20 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-6"
      >
        <mat-icon class="text-amber-600 text-5xl! w-12! h-12!">cookie</mat-icon>
      </div>

      <h1 id="cookies-disabled-title" class="text-2xl font-dm font-bold text-ld-neutral mb-4">
        {{ t('authCookiesDisabledTitle') }}
      </h1>

      <p id="cookies-disabled-description" class="font-dm text-ld-neutral-600 mb-6 leading-relaxed">
        {{ t('authCookiesDisabledDescription') }}
      </p>

      <div id="cookies-disabled-instructions" class="p-4 bg-ld-neutral-50 rounded-xl mb-6 text-left">
        <h2 class="font-dm font-semibold text-ld-neutral text-sm mb-2">{{ t('authCookiesDisabledHowToEnable') }}</h2>
        <p class="font-dm text-sm text-ld-neutral-600">
          {{ getBrowserInstructions() }}
        </p>
      </div>

      <div id="cookies-disabled-why" class="p-4 bg-blue-50 border border-blue-200 rounded-xl mb-6 text-left">
        <div class="flex items-start gap-3">
          <mat-icon class="text-blue-600 shrink-0 mt-0.5">info_outline</mat-icon>
          <div>
            <h3 class="font-dm font-medium text-blue-800 text-sm mb-1">{{ t('authCookiesDisabledWhyTitle') }}</h3>
            <p class="font-dm text-xs text-blue-700">
              {{ t('authCookiesDisabledWhyDescription') }}
            </p>
          </div>
        </div>
      </div>

      <button
        id="cookies-disabled-retry-btn"
        type="button"
        class="w-full px-6 py-3 text-base font-dm font-bold text-white bg-ld-primary rounded-xl hover:bg-ld-primary-600 transition-colors cursor-pointer"
        (click)="onRetry()"
      >
        {{ t('authCookiesDisabledRetryButton') }}
      </button>
    </div>
  </div>
</ng-container>
